<div class="modal-content" style="border-radius: 20px;">
  <div class="row justify-content-between ml-3 mr-3">
    <div class="new-dashboard-card" *ngIf="shouldShowMoveCityCreation()">
      <div>
        <h4>City creation has moved to our new dashboard!</h4>
        <h6>Follow this link to go there. Login with the same credentials. Text us with any issues at (646)-832-4695.</h6>
      </div>
      <button
        class="primary-medium-icon-left new-dashboard-card-button"
        id="dashboard-link"
        (click)="onClickDashboardRedirect()"
      >
        <i-feather name="external-link" class="icon"></i-feather>Take Me There
      </button>
    </div> 
    <div *ngIf="!shouldShowMoveCityCreation()">
      <div class="modal-title heading2" style="cursor:default;">{{ title }}</div>
      <button
        id="x_image"
        type="button"
        (click)="modalRef.hide()"
        class="modal-close"
        aria-hidden="false"
      ></button>
    <div class="modal-body">
      <form [formGroup]="form">
        <div class="section-label subheading1">
          CITY DETAILS
        </div>
        <div class="row no-gutters justify-content-between">
          <div class="form-group" style="width: 66%;">
            <label for="name">
              <div class="section-label subheading2">CITY</div>
            </label>
            <input
              type="text"
              class="form-control form-control-lg body2"
              id="name"
              formControlName="name"
              placeholder="Ex. Chicago"
              maxlength="30"
          />
        </div>
        <div class="form-group" style="width: 30%;">
          <label for="state">
            <div class="section-label subheading2">STATE</div>
          </label>
          <select
            style="height: 40px;"
            class="form-control form-control-lg body3"
            id="state"
            formControlName="state"
          >
            <option value="">Select</option>
            <option value="AL">Alabama</option>
            <option value="AK">Alaska</option>
            <option value="AZ">Arizona</option>
            <option value="AR">Arkansas</option>
            <option value="CA">California</option>
            <option value="CO">Colorado</option>
            <option value="CT">Connecticut</option>
            <option value="DE">Delaware</option>
            <option value="DC">District Of Columbia</option>
            <option value="FL">Florida</option>
            <option value="GA">Georgia</option>
            <option value="HI">Hawaii</option>
            <option value="ID">Idaho</option>
            <option value="IL">Illinois</option>
            <option value="IN">Indiana</option>
            <option value="IA">Iowa</option>
            <option value="KS">Kansas</option>
            <option value="KY">Kentucky</option>
            <option value="LA">Louisiana</option>
            <option value="ME">Maine</option>
            <option value="MD">Maryland</option>
            <option value="MA">Massachusetts</option>
            <option value="MI">Michigan</option>
            <option value="MN">Minnesota</option>
            <option value="MS">Mississippi</option>
            <option value="MO">Missouri</option>
            <option value="MT">Montana</option>
            <option value="NE">Nebraska</option>
            <option value="NV">Nevada</option>
            <option value="NH">New Hampshire</option>
            <option value="NJ">New Jersey</option>
            <option value="NM">New Mexico</option>
            <option value="NY">New York</option>
            <option value="NC">North Carolina</option>
            <option value="ND">North Dakota</option>
            <option value="OH">Ohio</option>
            <option value="OK">Oklahoma</option>
            <option value="OR">Oregon</option>
            <option value="PA">Pennsylvania</option>
            <option value="RI">Rhode Island</option>
            <option value="SC">South Carolina</option>
            <option value="SD">South Dakota</option>
            <option value="TN">Tennessee</option>
            <option value="TX">Texas</option>
            <option value="UT">Utah</option>
            <option value="VT">Vermont</option>
            <option value="VA">Virginia</option>
            <option value="WA">Washington</option>
            <option value="WV">West Virginia</option>
            <option value="WI">Wisconsin</option>
            <option value="WY">Wyoming</option>
          </select>
        </div>
      </div>

      <div class="form-group" *ngIf="usingCoordinates">
        <div class="row no-gutters justify-content-between">
          <div class="form-group" style="width: 45%;">
            <label for="latitude">
              <div class="section-label subheading1">LATITUDE</div>
            </label>
            <input
              type="number"
              class="form-control form-control-lg body2"
              id="latitude"
              formControlName="latitude"
              maxlength="10"
              [placeholder]="42.2808"
            />
          </div>
          <div class="form-group" style="width: 45%;">
            <label for="longitude">
              <div class="section-label subheading1">LONGITUDE</div>
            </label>
            <input
              type="number"
              class="form-control form-control-lg body2"
              id="longitude"
              formControlName="longitude"
              maxlength="10"
              [placeholder]="-83.743"
            />
          </div>
        </div>
      </div>

      <div class="app-status-container">
        <div class="section-label subheading2">
          APP STATUS
        </div>
        <div class="form-check form-check-inline">
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="visible"
              formControlName="isActive"
              [value]="true"
              class="custom-control-input"
            />
            <label
              class="custom-control-label body2"
              for="visible"
              style="line-height: 32px;"
              >Visible</label
            >
          </div>
        </div>
        <div class="form-check form-check-inline">
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="hidden"
              formControlName="isActive"
              [value]="false"
              class="custom-control-input"
            />
            <label
              class="custom-control-label body2"
              for="hidden"
              style="line-height: 32px;"
              >Hidden</label
            >
          </div>
        </div>
      </div>

      <div class="thumbnail-container">
        <div class="section-label subheading2">
          THUMBNAIL
        </div>
        <div class="image-container">
          <img src="{{ image }}" *ngIf="imageSelected()" />
          <div class="placeholder" *ngIf="!imageSelected()"></div>
          <div class="form-group">
            <input
              class="file-input add body2"
              type="file"
              (change)="selectImage($event)"
              accept=".png,.jpg"
              *ngIf="!imageSelected()"
            />
            <input
              class="file-input change body2"
              type="file"
              (change)="selectImage($event)"
              accept=".png,.jpg"
              *ngIf="imageSelected()"
            />
          </div>
        </div>
      </div>
      <div class="section-label subheading1">
        ADVERTISING
      </div>
      <div class="app-status-container">
        <div class="section-label subheading2">
          BANNER AD STATUS
        </div>
        <div class="form-check form-check-inline">
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="bannerActive"
              formControlName="isBannerActive"
              [value]="true"
              class="custom-control-input"
            />
            <label
              class="custom-control-label body2"
              for="bannerActive"
              style="line-height: 32px;"
              >Visible</label
            >
          </div>
        </div>
        <div class="form-check form-check-inline">
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="bannerHidden"
              formControlName="isBannerActive"
              [value]="false"
              class="custom-control-input"
            />
            <label
              class="custom-control-label body2"
              for="bannerHidden"
              style="line-height: 32px;"
              >Hidden</label
            >
          </div>
        </div>
      </div>
      <div class="form-group" style="width: 66%;" *ngIf="isBannerActive">
        <label for="bannerText">
          <div class="section-label subheading2">Banner AD TEXT</div>
        </label>
        <input
          type="text"
          class="form-control form-control-lg body2"
          id="bannerText"
          formControlName="bannerText"
          placeholder="Ex. City Sponsor"
          maxlength="50"
        />
      </div>
      <div class="banner-container" *ngIf="isBannerActive">
        <div class="section-label subheading2">
          BANNER AD IMAGE (320X50)
        </div>
        <div class="banner-image-container">
          <img src="{{ bannerImage }}" *ngIf="bannerSelected()" />
          <div class="ad-placeholder" *ngIf="!bannerSelected()"></div>
          <div class="form-group">
            <input
              class="file-input add body2"
              type="file"
              (change)="selectBannerImage($event)"
              accept=".png,.jpg"
              *ngIf="!bannerSelected()"
            />
            <input
              class="file-input change body2"
              type="file"
              (change)="selectBannerImage($event)"
              accept=".png,.jpg"
              *ngIf="bannerSelected()"
            />
          </div>
        </div>
      </div>

      <div class="app-status-container" *ngIf="isBannerActive">
        <div class="section-label subheading2">
          BANNER REDIRECT STATUS
        </div>
        <div class="form-check form-check-inline">
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="bannerRedirectActive"
              formControlName="isBannerRedirectActive"
              [value]="true"
              class="custom-control-input"
            />
            <label
              class="custom-control-label body2"
              for="bannerRedirectActive"
              style="line-height: 32px;"
              >On</label
            >
          </div>
        </div>
        <div class="form-check form-check-inline">
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="bannerRedirectInactive"
              formControlName="isBannerRedirectActive"
              [value]="false"
              class="custom-control-input"
            />
            <label
              class="custom-control-label body2"
              for="bannerRedirectInactive"
              style="line-height: 32px;"
              >Off</label
            >
          </div>
        </div>
      </div>

      <div
        class="form-group"
        *ngIf="isBannerActive && isBannerRedirectActive"
      >
        <label for="bannerRedirectUrl">
          <div class="section-label subheading2">BANNER REDIRECT URL</div>
        </label>
        <input
          type="text"
          class="form-control form-control-lg body2"
          id="bannerRedirectUrl"
          formControlName="bannerRedirectUrl"
          placeholder="Ex. https://www.lineleap.com/brand-ambassadors"
          maxlength="150"
        />
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <div
      type="submit"
      class="submit-city-container"
      (click)="validate(cities)"
      *ngIf="cities$ | async as cities"
    >
      <div class="submit-text label1">{{ button }}</div>
    </div>
  </div> 
  </div>
</div>
